<template>
  <div class="dash-board" ref="mylayout">
    <div>
      <Logo />
      <Header />
    </div>
    <div class="content">
      <router-view />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/view/dashBoard/Header.vue";
import Logo from "@/view/dashBoard/Logo.vue";
import Footer from "@/view/dashBoard/Footer.vue";
export default {
  name: "DashBoard",
  components: {
    Header,
    Logo,
    Footer,
  },
  mounted() {
    this.$bus.$on("myScrollTop", () => {
     const mylayout =  this.$refs.mylayout;
     mylayout.scrollTo({top:0,behavior:"smooth"})
    });
  },
  beforeDestroy() {
    this.$bus.$off("myScrollTop");
  },
};
</script>

<style lang="less" scoped>
.dash-board {
  position: relative;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .content {
    flex: 1;
  }
}
</style>
